__turbopack_context__.v({
  "breakdownCount": "CustomerReviewsFull-module__m10zhG__breakdownCount",
  "breakdownFill": "CustomerReviewsFull-module__m10zhG__breakdownFill",
  "breakdownList": "CustomerReviewsFull-module__m10zhG__breakdownList",
  "breakdownRow": "CustomerReviewsFull-module__m10zhG__breakdownRow",
  "breakdownStar": "CustomerReviewsFull-module__m10zhG__breakdownStar",
  "breakdownStarCount": "CustomerReviewsFull-module__m10zhG__breakdownStarCount",
  "breakdownTrack": "CustomerReviewsFull-module__m10zhG__breakdownTrack",
  "carouselDots": "CustomerReviewsFull-module__m10zhG__carouselDots",
  "galleryBlock": "CustomerReviewsFull-module__m10zhG__galleryBlock",
  "galleryGrid": "CustomerReviewsFull-module__m10zhG__galleryGrid",
  "galleryMain": "CustomerReviewsFull-module__m10zhG__galleryMain",
  "galleryOverlay": "CustomerReviewsFull-module__m10zhG__galleryOverlay",
  "galleryThumb": "CustomerReviewsFull-module__m10zhG__galleryThumb",
  "galleryThumbButton": "CustomerReviewsFull-module__m10zhG__galleryThumbButton",
  "galleryThumbs": "CustomerReviewsFull-module__m10zhG__galleryThumbs",
  "galleryTitle": "CustomerReviewsFull-module__m10zhG__galleryTitle",
  "header": "CustomerReviewsFull-module__m10zhG__header",
  "highlightTag": "CustomerReviewsFull-module__m10zhG__highlightTag",
  "highlightTags": "CustomerReviewsFull-module__m10zhG__highlightTags",
  "highlightsBlock": "CustomerReviewsFull-module__m10zhG__highlightsBlock",
  "highlightsTitle": "CustomerReviewsFull-module__m10zhG__highlightsTitle",
  "mobileCarousel": "CustomerReviewsFull-module__m10zhG__mobileCarousel",
  "mobileSlide": "CustomerReviewsFull-module__m10zhG__mobileSlide",
  "mobileSummary": "CustomerReviewsFull-module__m10zhG__mobileSummary",
  "quoteIcon": "CustomerReviewsFull-module__m10zhG__quoteIcon",
  "reviewAvatar": "CustomerReviewsFull-module__m10zhG__reviewAvatar",
  "reviewCard": "CustomerReviewsFull-module__m10zhG__reviewCard",
  "reviewDate": "CustomerReviewsFull-module__m10zhG__reviewDate",
  "reviewGrid": "CustomerReviewsFull-module__m10zhG__reviewGrid",
  "reviewHeader": "CustomerReviewsFull-module__m10zhG__reviewHeader",
  "reviewImages": "CustomerReviewsFull-module__m10zhG__reviewImages",
  "reviewName": "CustomerReviewsFull-module__m10zhG__reviewName",
  "reviewStars": "CustomerReviewsFull-module__m10zhG__reviewStars",
  "reviewText": "CustomerReviewsFull-module__m10zhG__reviewText",
  "reviewUser": "CustomerReviewsFull-module__m10zhG__reviewUser",
  "scoreBadge": "CustomerReviewsFull-module__m10zhG__scoreBadge",
  "scoreValue": "CustomerReviewsFull-module__m10zhG__scoreValue",
  "section": "CustomerReviewsFull-module__m10zhG__section",
  "stars": "CustomerReviewsFull-module__m10zhG__stars",
  "summaryColumn": "CustomerReviewsFull-module__m10zhG__summaryColumn",
  "summaryCopy": "CustomerReviewsFull-module__m10zhG__summaryCopy",
  "summaryLabel": "CustomerReviewsFull-module__m10zhG__summaryLabel",
  "summaryMeta": "CustomerReviewsFull-module__m10zhG__summaryMeta",
  "summaryPanel": "CustomerReviewsFull-module__m10zhG__summaryPanel",
  "summaryTop": "CustomerReviewsFull-module__m10zhG__summaryTop",
  "viewAllBtn": "CustomerReviewsFull-module__m10zhG__viewAllBtn",
  "viewAllWrap": "CustomerReviewsFull-module__m10zhG__viewAllWrap",
  "writeBtn": "CustomerReviewsFull-module__m10zhG__writeBtn",
  "writeBtnMobile": "CustomerReviewsFull-module__m10zhG__writeBtnMobile",
});
